module.exports = __webpack_public_path__ + "img/工作真实性-影像信息@2x.4d116b03.png";